import { render, staticRenderFns } from "./MoleculeContentEditorModalFileExtensionError.vue?vue&type=template&id=cce236a8"
import script from "./MoleculeContentEditorModalFileExtensionError.vue?vue&type=script&lang=js"
export * from "./MoleculeContentEditorModalFileExtensionError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports